import { Container, Grid, MenuItem } from "@mui/material";
import { Form, Field } from "react-final-form";
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect, useRef } from "react";
import UiInput from "../../../_uiComponents/UiInput";
import { UiButton } from "../../../_uiComponents/common/UiButton";
import { useTranslation } from "react-i18next";
import { authConstants, commonConstants } from "../../../../_redux/_constants";

import {
  creditCardNumberFormatter,
  creditCardNumberRestorer,
  debitCardFormatter,
  formatDebitCardInput,
} from "../../../../_helpers/creditCard.helper";
import * as yup from "yup";
import Validator from "../../../../_helpers/validate.schema";
import { NumericFormat } from "react-number-format";
import { validCreditCard } from "../../../../_helpers/support.services";
import UiSelectM from "../../../_uiComponents/common/UiSelectCard";
import { accountTypesConstants } from "../../../../_redux/_constants";
import {
  forgotPasswordAccountConfirmRequest,
  setForgotPasswordFormData,
} from "../../../../_redux/_actions";
import { UiDateInput } from "../../../_uiComponents/common/UiDateInput";
import moment from "moment";

const validateSchema = () =>
  yup.object().shape({
    bankAccountNo: yup.string().required("Bank Account Number is Required."),
    dateOfBirth: yup.string().required("Date of Birth is Required."),
    registeredType: yup.string().required("Account Type is Required."),
  });

export const ForgetPasswordAccountDetailsForm = (props) => {
  const forgotFormData = useSelector((state) => state.auth.forgotFormData);
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const formRef = useRef(null);

  const onSubmit = async (values) => {
    dispatch(setForgotPasswordFormData(values));
    const payload = {
      registeredType: values.registeredType,
      bankAccountNo: values.bankAccountNo,
      dateOfBirth: moment(values.dateOfBirth).format("DD-MM-YYYY"),
    };
    dispatch(forgotPasswordAccountConfirmRequest(payload));
  };

  const handleButtonClick = (handleSubmit) => {
    handleSubmit();
  };

  useEffect(() => {
    if (forgotFormData && formRef.current) {
      formRef.current.initialize(forgotFormData);
    }
  }, [forgotFormData]);

  const onValidate = async (values) => {
    return await Validator(values, validateSchema);
  };
  return (
    <Form
      initialValues={{
        registeredType: accountTypesConstants.CASA_ACCOUNT_TYPE,
        bankAccountNo: "",
        dateOfBirth: "",
      }}
      onSubmit={onSubmit}
      validate={onValidate}
      render={({
        handleSubmit,
        submitting,
        hasValidationErrors,
        form,
        values,
        errors,
      }) => {
        formRef.current = form;

        return (
          <form onSubmit={handleSubmit}>
            <UiSelectM
              form={form}
              name="registeredType"
              label={"Account Type *"}
              value={values?.registeredType}
              onChange={(e) => {
                form.change("registeredType", e.target.value);
              }}
            >
              {accountTypesConstants.REGISTERED_ACCOUNT_TYPE_LIST.map(
                (option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ),
              )}
            </UiSelectM>

            <UiInput
              name="bankAccountNo"
              label={t("Account Number *")}
              type="text"
              variant="outlined"
              value={values?.bankAccountNo}
              maxLength={16}
              inputonChange={(e) => {
                const input = e.target.value;
                form.change("bankAccountNo", input);
              }}
            />

            <UiDateInput
              name="dateOfBirth"
              value={values?.dateOfBirth}
              label={"Date of Birth (DD/MM/YYYY)"}
              format={commonConstants.COMMON_DATE_FORMAT_DD_MM_YYYY}
              onChange={(date) => {
                form.change(
                  "dateOfBirth",
                  moment(date).format(
                    commonConstants.COMMON_DATE_FORMAT_DD_MM_YYYY,
                  ),
                );
              }}
              className="df-date-input-border"
            />

            <UiButton
              className="df-ui-dark-bg-btn w-100 mt-2"
              name={t("Next")}
              type="button"
              disabled={hasValidationErrors || submitting}
              onClick={() => handleButtonClick(handleSubmit)}
            />
          </form>
        );
      }}
    />
  );
};
